import * as React from "react";
import { useTranslation } from "react-i18next";
import { Spinner } from "components/common";
import ExpandedSectionCount from "components/common/EntityDataTable/ExpandedSectionCount";
import { useInputMetricsFor } from "components/inputs/InputsOveriew/InputMetricsContext";
import { METRIC_COLUMN_IDS } from "components/inputs/InputsOveriew/metricColumns";
const SECTION_NAME = METRIC_COLUMN_IDS.extractorCount;
const ExtractorCountCell = ({ input }) => {
  const { t } = useTranslation("inputs");
  const { metrics, isInitialLoading, isError } = useInputMetricsFor(input.id);
  if (isInitialLoading && !metrics) {
    return /* @__PURE__ */ React.createElement(Spinner, { size: "xs" });
  }
  if (isError || (metrics == null ? void 0 : metrics.extractor_count) === void 0) {
    return /* @__PURE__ */ React.createElement("span", { "aria-label": t("overview.cells.no_extractor_count", { title: input.title }) }, "\u2014");
  }
  return /* @__PURE__ */ React.createElement(
    ExpandedSectionCount,
    {
      entityId: input.id,
      section: SECTION_NAME,
      count: metrics.extractor_count,
      label: t("overview.cells.extractors_label", { title: input.title })
    }
  );
};
export default ExtractorCountCell;
